import { request } from "@/utilities/libs/request.ts";
import { IRequestArgs, ListResponseData } from "@/utilities/types/requests.ts";
import { ERequestMethods } from "@/utilities/enums/RequestMethod.ts";
import { IIPTracking } from "../types/IPTracking";
import dayjs from "dayjs";

function getAll({ queryParams }: IRequestArgs) {
  const filterQuery = Object.assign({}, ...(queryParams?.query?.filter ?? []));

  // Build params with pagination
  const params: Record<string, any> = {
    ...queryParams?.pagination,
    ...filterQuery,
  };

  // Convert dates to ISO string if they exist and are valid dates
  if (params.startDate) {
    const startDate = dayjs(params.startDate);
    if (startDate.isValid()) {
      params.startDate = startDate.startOf("day").toISOString();
    }
  }
  if (params.endDate) {
    const endDate = dayjs(params.endDate);
    if (endDate.isValid()) {
      params.endDate = endDate.endOf("day").toISOString();
    }
  }

  return request<ListResponseData<IIPTracking>>({
    method: ERequestMethods.GET,
    url: "/ip-tracking/all",
    params,
  });
}

const IPTrackingRepository = Object.freeze({
  getAll,
});

export default IPTrackingRepository;
